import React from "react";
import { NestedComments } from "./NestedComments";
import { ChevronDown } from "lucide-react";

export function CommentsList({
  comments,
  currentUserId,
  currentUserEmail,
  currentUserUsername,
  onReply,
  onEdit,
  onLike,
  onView,
  showCommentEditor,
  replyingTo,
  onComment,
  backendUrl,
  profilePicture,
  avatar,
  handleSeen,
  handleRemoveFile,
  handleDeleteComment,
  setIsEditing,
  isEditing,
  isLoading = false,
}) {
  const [showAllComments, setShowAllComments] = React.useState(true);

  if (!Array.isArray(comments) || comments.length === 0) {
    if (isLoading) {
      return (
        <div className="space-y-3 animate-pulse">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
          </div>
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex space-x-3">
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return null;
  }

  if (!showAllComments) {
    return (
      <button
        onClick={() => setShowAllComments(true)}
        className="flex items-center gap-3 text-gray-600 hover:text-gray-800 group w-full"
      >
        <div className="flex -space-x-2">
          {comments.slice(0, 3).map((comment) => (
            <div
              key={comment.id}
              className="w-8 h-8 rounded-full border-2 border-white overflow-hidden"
            >
              <img
                src={
                  comment?.user?.avatar?.url
                    ? `${backendUrl}${comment?.user?.avatar?.url}`
                    : profilePicture
                }
                alt={comment?.user?.name}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
          {comments.length > 3 && (
            <div className="w-8 h-8 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center text-md font-semibold text-gray-500">
              +{comments.length - 3}
            </div>
          )}
        </div>
        <span className="text-md font-semibold">
          {comments.length}{" "}
          {comments.length === 1 ? "comentario" : "comentarios"}
        </span>
        <ChevronDown
          size={16}
          className="text-gray-400 group-hover:text-gray-600 transition-transform duration-200"
        />
      </button>
    );
  }
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between text-md text-gray-500 mb-2">
        <span className="font-semibold flex items-center gap-2">
          {comments.length}{" "}
          {comments.length === 1 ? "comentario" : "comentarios"}
          {isLoading && (
            <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          )}
        </span>
        <button
          onClick={() => setShowAllComments(false)}
          className="flex items-center gap-1 hover:text-gray-700"
        >
          <span>Ocultar comentarios</span>
          <ChevronDown size={16} className="transform rotate-180" />
        </button>
      </div>
      <NestedComments
        comments={comments}
        parentId={null}
        depth={0}
        currentUserId={currentUserId}
        currentUserEmail={currentUserEmail}
        currentUserUsername={currentUserUsername}
        onReply={onReply}
        onEdit={onEdit}
        onLike={onLike}
        onView={onView}
        showCommentEditor={showCommentEditor}
        replyingTo={replyingTo}
        onComment={onComment}
        backendUrl={backendUrl}
        profilePicture={profilePicture}
        avatar={avatar}
        handleSeen={handleSeen}
        handleRemoveFile={handleRemoveFile}
        onDeleteComment={handleDeleteComment}
        setIsEditing={setIsEditing}
        isEditing={isEditing}
      />
    </div>
  );
}
